import { render } from "./SidebarIcon16.vue.js?vue&type=template&id=0cf9104c!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./SidebarIcon16.vue?vue&type=template&id=0cf9104c"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__